import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import BEMHelper from '@ynap/bem-helper';
import { withOptimizely } from '@ynap/optimizely-utils';

const bem = new BEMHelper('PasswordInput');

class PasswordInput extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        showText: PropTypes.string,
        hideText: PropTypes.string,
        optimizely: PropTypes.object,
    };

    constructor() {
        super();
        this.state = {};
    }

    toggleVisibility = (e) => {
        e.preventDefault();
        this.setState({ visible: !this.state.visible });
    };

    render() {
        const { className, hideText, showText, hasError, optimizely, ...rest } = this.props; // eslint-disable-line no-unused-vars
        const { visible } = this.state;

        const onFocus = () => optimizely?.track('account_passwordfields');

        return (
            <div className={bem(null, null, className)}>
                <input {...rest} onFocus={onFocus} type={visible ? 'text' : 'password'} className={bem('input')} autoComplete="password" />
                <button type="button" onClick={this.toggleVisibility} className={bem('toggle', { visible })}>
                    {visible ? hideText : showText}
                </button>
            </div>
        );
    }
}

export default withOptimizely(PasswordInput);
